import { Store } from '@datorama/akita';
import { DynamicSchemaModel } from './dynamic-schema.model';

export class DynamicSchemaStore extends Store<DynamicSchemaModel> {
  public constructor(schemaName: string) {
      super(new DynamicSchemaModel(), { cache : { ttl : 15000}, name : `${schemaName}-schema`});
    }
  }

